import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=25acd8c2&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SwitchButtons: require('/home/bitrix/lka/frontend/components/switchButtons.vue').default,Notify: require('/home/bitrix/lka/frontend/components/notify.vue').default,User: require('/home/bitrix/lka/frontend/components/user.vue').default})
